import React, { Component } from 'react';
import {
  //BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';
import store from '../../store';
import jwt_decode from 'jwt-decode';
import setAuthToken from '../../utils/setAuthToken';
import { setCurrentUser, logoutUser } from '../../actions/authActions';
import { clearCurrentProfile } from '../../actions/profileAction';
import PrivateRoute from '../../components/common/PrivateRoute';

import ConferenceTemplate from '../../components/pages/ConferenceTemplate';
import StudentStatPage from '../../components/pages/StudentStatPage';
import StudentHome from '../../components/pages/StudentHome';
import homePage from '../../components/home/homePage';
import AdminStatistic from '../../components/pages/AdminStatistic';
import ChangeConfInfo from '../../components/add-elements/ChangeConfInfo';
import AddStudentsPage from '../../components/pages/AddStudentsPage';

import Login from '../../components/auth/Login';
import Register from '../../components/auth/Register';
import EditProfile from '../../components/edit-profile/EditProfile';
import Profiles from '../../components/profiles/Profiles';
import ProfileEdit from '../../components/profiles/ProfileEdit';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';

import { style } from '../../variables/Variables.jsx';

import adminRoutes from '../../routes/admin.jsx';
import studentRoutes from '../../routes/student.jsx';

//Check for token
if (localStorage.jwtToken) {
  // Set auth token header auth
  setAuthToken(localStorage.jwtToken);
  // Decode token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
    // Clear current Profile
    store.dispatch(clearCurrentProfile());
    // Redirect to login
    window.location.href = '/login';
  }
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.state = {
      _notificationSystem: null
    };
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf('nav-open') !== -1
    ) {
      document.documentElement.classList.toggle('nav-open');
    }
    if (e.history.action === 'PUSH') {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    let route;
    if (this.props.auth.isAuthenticated) {
      if (this.props.auth.user.position === 'Admin') {
        route = adminRoutes;
      } else if (this.props.auth.user.position === 'Student') {
        route = studentRoutes;
      } else {
        route = studentRoutes;
        console.log("error");
      }
    } else {
      route = [{ redirect: true, path: '/', to: '/login', name: 'Login' }];
    }
    return (
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} />
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <Header {...this.props} />
          <Route exact path="/login" component={Login} />
          <Switch>
            {route.map((prop, key) => {
              if (prop.name === 'Notifications')
                return (
                  <Route
                    path={prop.path}
                    key={key}
                    render={routeProps => (
                      <prop.component
                        {...routeProps}
                        handleClick={this.handleNotificationClick}
                      />
                    )}
                  />
                );
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.to} key={key} />;
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          <Switch>
            <PrivateRoute exact path="/home" component={homePage} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/AdminStatistic" component={AdminStatistic} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/AdminStatistic/AddStudents" component={AddStudentsPage} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/studentStat" component={StudentStatPage} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/studentHome" component={StudentHome} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/AdminStatistic/ChangeConfInfo/:_id' component={ChangeConfInfo} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/AdminStatistic/ConferenceTemplate/:_id" component={ConferenceTemplate} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/edit-profile" component={EditProfile} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/profiles" component={Profiles} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/profiles/:id" component={ProfileEdit} />
          </Switch>
          <Switch>
            <PrivateRoute exact path="/register" component={Register} />
          </Switch>
          <Footer />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(mapStateToProps)(Dashboard);
